import { render } from "./CoachAddUpdateModal.vue?vue&type=template&id=7b57dc0c"
import script from "./CoachAddUpdateModal.vue?vue&type=script&lang=js"
export * from "./CoachAddUpdateModal.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__